export default "__VITE_ASSET__BoaAN8bG__"